import { createTheme, ThemeOptions } from "@mui/material/styles";
import { pink, yellow, red, blue, green } from "@mui/material/colors";

import {
  brandPrimary,
  brandPrimaryFocus,
  brandSecondary,
  brandSecondaryFocus,
} from "../../../constants";

// Extend MUI's default theme to include `MuiDataGrid`
declare module "@mui/material/styles" {
  interface Components {
    MuiDataGrid?: {
      styleOverrides?: {
        root?: {
          border: string;
          "& .MuiDataGrid-withBorderColor"?: {
            borderColor: string;
          };
        };
      };
    };
  }
}

// Create the theme object first to access the palette
const { palette } = createTheme();

// Define the custom theme type based on the `ThemeOptions` interface
const customThemeOptions: ThemeOptions = {
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "#dee2e6",
          },
        },
      },
    },
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    pinky: palette.augmentColor({ color: pink }),
    summer: palette.augmentColor({ color: yellow }),
    primary: {
      main: brandPrimary,
      dark: brandPrimaryFocus,
      contrastText: "#ffffff",
      text: "#212529",
    },
    secondary: {
      main: brandSecondary,
      dark: brandPrimaryFocus,
      focus: brandSecondaryFocus,
      contrastText: "#ffffff",
    },
    success: palette.augmentColor({ color: green }),
    warning: palette.augmentColor({ color: yellow }),
    danger: palette.augmentColor({ color: red }),
    link: palette.augmentColor({ color: blue }),
    light: {
      main: "#ffffff",
      focus: "#ffffff",
      dark: "#ffffff",
      contrastText: "#212529",
    },
    dark: {
      main: "#212529",
      focus: "#212529",
      dark: "#212529",
      contrastText: "#212529",
      text: "#212529",
    },
    grey: {
      main: "rgba(23, 23, 23, 0.1)",
      focus: "rgba(23, 23, 23, 0.1)",
      dark: "rgba(23, 23, 23, 0.1)",
      contrastText: "rgba(23, 23, 23, 0.1)",
      text: "rgba(23, 23, 23, 0.1)",
    },
    white: {
      main: "#ffffff",
      focus: "#ffffff",
      dark: "#ffffff",
      contrastText: "#ffffff",
      text: "#ffffff",
    },
    mode: "light",
    type: "light",
    background: {
      default: "#ffffff",
      paper: "rgb(239, 241, 244)",
    },
    mixins: {
      toolbar: {
        minHeight: 64,
      },
    },
  },
};

export default customThemeOptions;